(function () {
  angular.module("akitabox.ui.dialogs.document.revert", [
    "akitabox.core.constants",
    "akitabox.core.services.document",
    "akitabox.core.toast",
  ]);
})();
